import { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const GALLERY_IMAGES = [
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/01a49028-6e2c-4595-a935-7620f709595c_WhatsApp-Image-2026-03-26-at-10.50.33-AM.jpeg?v=5961470f974d1872b599fdfa5b2f675f",
    alt: "Blue Moon Beauty Salon - Luxury Treatment Muscat",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/ee79bbc8-292b-433a-aa9a-9e22fef2ab3a_WhatsApp-Image-2026-03-26-at-10.50.34-AM.jpeg?v=ce4a09efae30810428bdab5cad1a6772",
    alt: "Blue Moon Beauty Salon - Spa Experience Muscat",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/0dbba706-3ed9-4eb3-a474-bdbc6676323b_WhatsApp-Image-2026-03-26-at-10.50.25-AM.jpeg?v=eaeb12882a2ac55faf9e221e4b222ff9",
    alt: "Blue Moon Beauty Salon - Professional Beauty Service",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/8b9c2936-a187-43ae-b35a-276e900c5d34_WhatsApp-Image-2026-03-26-at-10.50.26-AM-1.jpeg?v=79043c5d8fa70b84ab90054e82363ab8",
    alt: "Blue Moon Salon - Hair & Beauty Al Koudh",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/e3a6d535-bd1a-4fb9-97d4-e7404428de53_WhatsApp-Image-2026-03-26-at-10.50.26-AM-2.jpeg?v=0581708e046192a1851302f2581232a0",
    alt: "Blue Moon Beauty Salon - Premium Services Oman",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/ecc3c875-b620-4543-8fc7-12d5efb13f58_WhatsApp-Image-2026-03-26-at-10.50.26-AM.jpeg?v=f622d01e0afeee5a9786002187bcdc2b",
    alt: "Blue Moon Beauty Salon & Spa - Muscat Oman",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/2d72a372-7f6f-41da-a480-501ec443d5e7_WhatsApp-Image-2026-03-26-at-10.50.27-AM-1.jpeg?v=2f0e79243e27dbc091f4f37db03fff9f",
    alt: "Blue Moon Salon - Expert Beauty Treatments Muscat",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/53fedce0-14d9-4947-85f3-b8de45ad3288_WhatsApp-Image-2026-03-26-at-10.50.27-AM-2.jpeg?v=021d9b386d2facd8efac727d61094dd1",
    alt: "Blue Moon Beauty Salon - Elegant Beauty Experience",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/a73e69eb-2fdc-4c57-ae97-eaaee1a8bfa7_WhatsApp-Image-2026-03-26-at-10.50.27-AM.jpeg?v=b43670f30bb9fd9f1d5af66d9534c12c",
    alt: "Blue Moon Salon - Luxury Salon Interior Muscat",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/124b6507-8da2-40a1-8cad-03339fe2be2f_WhatsApp-Image-2026-03-26-at-10.50.28-AM-1.jpeg?v=8f200f2dff46ab94493f41190373c195",
    alt: "Blue Moon Beauty Salon - Professional Treatments",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/cb859a6e-8614-4c08-ac7c-8a522ab1ecb7_WhatsApp-Image-2026-03-26-at-10.50.28-AM-2.jpeg?v=6d0746fd734377cebbfd1cdffd53890e",
    alt: "Blue Moon Beauty Salon - Skincare & Wellness Oman",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/b77c8f43-e358-44ad-b651-5fbee075f9fe_WhatsApp-Image-2026-03-26-at-10.50.28-AM-3.jpeg?v=87aff73275b517d7fbd5dd74016a9fee",
    alt: "Blue Moon Salon - Beauty & Spa Al Koudh Muscat",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/549a87bc-8dd5-4c2e-92ec-cc3b4dd38bde_WhatsApp-Image-2026-03-26-at-10.50.28-AM.jpeg?v=2b139a4f67aaa4c1744d5503f48c41cf",
    alt: "Blue Moon Beauty Salon - Luxury Spa Treatments",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/0e6efb3f-4255-44d8-ab3a-065af86c4898_WhatsApp-Image-2026-03-26-at-10.50.29-AM-1.jpeg?v=c1b95bb6182a257c982eaf1641dc5835",
    alt: "Blue Moon Beauty Salon - Expert Beauticians Muscat",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/ffb13aa3-98dd-407e-9a14-4d8cf649352d_WhatsApp-Image-2026-03-26-at-10.50.29-AM-2.jpeg?v=da4f30b9600c851ef72eea82145f3308",
    alt: "Blue Moon Beauty Salon & Spa - Premium Experience Oman",
  },
];

export default function GalleryPage() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const openLightbox = (i: number) => setLightboxIndex(i);
  const closeLightbox = () => setLightboxIndex(null);

  const goPrev = useCallback(() => {
    setLightboxIndex((i) => (i === null ? null : (i - 1 + GALLERY_IMAGES.length) % GALLERY_IMAGES.length));
  }, []);

  const goNext = useCallback(() => {
    setLightboxIndex((i) => (i === null ? null : (i + 1) % GALLERY_IMAGES.length));
  }, []);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (lightboxIndex === null) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "ArrowRight") goNext();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lightboxIndex, goPrev, goNext]);

  useEffect(() => {
    document.body.style.overflow = lightboxIndex !== null ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [lightboxIndex]);

  return (
    <div className="w-full overflow-x-hidden">
      <Navbar />

      {/* Page Header */}
      <div className="relative w-full pt-24 sm:pt-28 pb-14 sm:pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={GALLERY_IMAGES[0].src}
            alt="Blue Moon Beauty Salon Gallery Header"
            className="w-full h-full object-cover object-center"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1a2744]/60 via-[#1a2744]/40 to-[#1a2744]/65"></div>
        </div>

        <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6">
          <div
            className="rounded-sm px-6 sm:px-10 py-8 sm:py-12 text-center"
            style={{
              background: "rgba(255,255,255,0.07)",
              backdropFilter: "blur(14px)",
              WebkitBackdropFilter: "blur(14px)",
              border: "1px solid rgba(198,168,100,0.25)",
              boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
            }}
          >
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4 border border-[#c6a864]/60"
              style={{ background: "rgba(198,168,100,0.12)" }}>
              <i className="ri-image-2-line text-[#c6a864] text-xl"></i>
            </div>
            <p className="text-[#c6a864] text-xs tracking-[0.4em] uppercase mb-3 font-light">
              Blue Moon Beauty Salon &amp; Spa — Al Koudh, Muscat
            </p>
            <h1
              className="text-white text-3xl sm:text-5xl font-light tracking-wide mb-2"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Our Gallery
            </h1>
            <p
              className="text-[#c6a864] text-2xl sm:text-3xl font-bold mb-3"
              style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
            >
              معرض صورنا
            </p>
            <div className="w-16 h-px bg-[#c6a864]/50 mx-auto mb-4"></div>
            <p className="text-white/70 text-sm leading-relaxed max-w-xl mx-auto">
              A glimpse into the world of Blue Moon — where every visit is a luxury experience in the heart of Al Koudh, Muscat.
            </p>
            <p
              className="text-white/55 text-sm leading-relaxed mt-2"
              style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
            >
              لمحة من عالم القمر الأزرق — حيث كل زيارة تجربة فاخرة في قلب الخوض، مسقط.
            </p>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent"></div>
      </div>

      {/* Gallery Grid */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">

          {/* Uniform 3-col grid — desktop */}
          <div className="hidden sm:grid grid-cols-3 gap-3">
            {GALLERY_IMAGES.map((img, i) => (
              <div
                key={i}
                className="relative overflow-hidden cursor-pointer group aspect-[4/3]"
                onClick={() => openLightbox(i)}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                  loading={i < 6 ? "eager" : "lazy"}
                />
                <div className="absolute inset-0 bg-[#1a2744]/0 group-hover:bg-[#1a2744]/30 transition-all duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div
                    className="w-12 h-12 flex items-center justify-center border border-white/80"
                    style={{ background: "rgba(198,168,100,0.85)" }}
                  >
                    <i className="ri-zoom-in-line text-white text-xl"></i>
                  </div>
                </div>
                {/* Index badge */}
                <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="text-white/70 text-[10px] tracking-widest">
                    {i + 1} / {GALLERY_IMAGES.length}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* 2-col grid — mobile */}
          <div className="grid sm:hidden grid-cols-2 gap-2">
            {GALLERY_IMAGES.map((img, i) => (
              <div
                key={i}
                className="relative overflow-hidden cursor-pointer group aspect-square"
                onClick={() => openLightbox(i)}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  loading={i < 4 ? "eager" : "lazy"}
                />
                <div className="absolute inset-0 bg-[#1a2744]/0 group-hover:bg-[#1a2744]/25 transition-all duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div
                    className="w-9 h-9 flex items-center justify-center"
                    style={{ background: "rgba(198,168,100,0.85)" }}
                  >
                    <i className="ri-zoom-in-line text-white text-base"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Caption */}
          <p className="text-center text-gray-300 text-xs tracking-widest uppercase mt-8">
            {GALLERY_IMAGES.length} photos — Blue Moon Beauty Salon &amp; Spa, Muscat
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 bg-[#f8f7f4]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">
          <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4 border border-[#ece8e0]">
            <i className="ri-moon-line text-[#c6a864] text-xl"></i>
          </div>
          <h2
            className="text-[#1a2744] text-2xl sm:text-3xl font-light mb-2"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Experience It For Yourself
          </h2>
          <p
            className="text-[#c6a864] text-xl font-bold mb-4"
            style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
          >
            عيشي التجربة بنفسك
          </p>
          <p className="text-gray-400 text-sm mb-8 max-w-md mx-auto">
            Book your appointment at Blue Moon Beauty Salon &amp; Spa, Al Koudh, Muscat and let us take care of you.
          </p>
          <a
            href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer bg-[#25D366] text-white text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-[#20ba5a] transition-colors duration-300"
          >
            <i className="ri-whatsapp-line text-base"></i>
            <span>Book via WhatsApp</span>
            <span style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>— احجزي الآن</span>
          </a>
        </div>
      </section>

      <Footer />

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ background: "rgba(10,14,30,0.96)" }}
          onClick={closeLightbox}
        >
          {/* Close */}
          <button
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center border border-white/30 text-white hover:border-[#c6a864] hover:text-[#c6a864] transition-colors cursor-pointer z-10"
            onClick={closeLightbox}
          >
            <i className="ri-close-line text-xl"></i>
          </button>

          {/* Prev */}
          <button
            className="absolute left-3 sm:left-6 w-10 h-10 flex items-center justify-center border border-white/30 text-white hover:border-[#c6a864] hover:text-[#c6a864] transition-colors cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); goPrev(); }}
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          {/* Image */}
          <div
            className="relative max-w-4xl w-full mx-16 sm:mx-20"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={GALLERY_IMAGES[lightboxIndex].src}
              alt={GALLERY_IMAGES[lightboxIndex].alt}
              className="w-full max-h-[80vh] object-contain"
            />
            <p className="text-white/50 text-xs text-center mt-3 tracking-widest">
              {lightboxIndex + 1} / {GALLERY_IMAGES.length}
            </p>
          </div>

          {/* Next */}
          <button
            className="absolute right-3 sm:right-6 w-10 h-10 flex items-center justify-center border border-white/30 text-white hover:border-[#c6a864] hover:text-[#c6a864] transition-colors cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); goNext(); }}
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>
        </div>
      )}
    </div>
  );
}
